import { useState } from 'react'

interface ModalStateContainerProps {
  children: ({
    isConfirmationOpen,
    toggleConfirm,
  }: {
    isConfirmationOpen: boolean
    toggleConfirm: (open: boolean, cb?: () => void) => void
  }) => React.ReactElement
}

export const ModalStateContainer = ({ children }: ModalStateContainerProps) => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)

  const toggleConfirm = (
    open: boolean = !isConfirmationOpen,
    cb: () => void = () => {}
  ) => {
    setIsConfirmationOpen(open)
    cb()
  }

  return children({
    isConfirmationOpen,
    toggleConfirm,
  })
}
